
<h4>Personalize seu seguro</h4>

<div class="card my-4">
    <div class="card-body">
   
        <form [formGroup]="form">

            <div class="row row-cols-1 row-cols-md-3">
                <div class="col">
                    <div class="form-group">
                        <label class="text-center w-100">
                            1- Qual a sua ocupação ?
                        </label>
                        <ng-select [items]="ocupacoes" bindLabel="DCR_OCUPACAO" bindValue="COD_OCUPACAO" formControlName="codOcupacao"></ng-select>
                    </div>
                </div>
                <div class="col text-center">
                    <div class="form-group">
                        <label>
                            2- Qual é sua renda mensal atual ?
                        </label>
                        <input type="text" 
                        class="form-control" 
                        name="valorRenda" 
                        formControlName="valorRenda" 
                        placeholder="000,00" 
                        maxlength="20"
                        mask="separator.2"
                        prefix="R$ "
                        thousandSeparator="."
                        decimalMarker=","
                        [dropSpecialCharacters]="true"
                        >
                    </div>
                </div>
                <div class="col text-center">
                    <div class="form-group">
                        <label class="d-block">
                            3- Aposentado INSS ?
                        </label>
                        
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" id="ckInssSim" value="S" formControlName="idcAposentado">
                            <label class="form-check-label" for="ckInssSim">Sim</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" id="ckInssNao" value="N" formControlName="idcAposentado">
                            <label class="form-check-label" for="ckInssNao">Não</label>
                        </div>
            
                    </div>
                </div>
            </div>

        </form>
    </div>
</div>


<app-comp-simulador-seguro #compSimuladorSeguro></app-comp-simulador-seguro>     


<div class="mt-3 row justify-content-between">
    <div class="col text-left">
        <button type="button" class="btn btn-primary" (click)="voltar()">
            <i class="fas fa-chevron-left"></i>
            Voltar            
        </button>
    </div>
    <div class="col text-right">
        <button type="button" class="btn btn-success" (click)="proximo()" [disabled]="loading || !form.valid || compSimuladorSeguro.premioTotal==0">
            Próximo
            <i class="fas fa-chevron-right"></i>
        </button>
    </div>
</div>